"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = forEachState;
/**
 *  Copyright (c) 2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

// Utility for iterating through a CodeMirror parse state stack bottom-up.
function forEachState(stack, fn) {
  var reverseStateStack = [];
  var state = stack;
  while (state && state.kind) {
    reverseStateStack.push(state);
    state = state.prevState;
  }
  for (var i = reverseStateStack.length - 1; i >= 0; i--) {
    fn(reverseStateStack[i]);
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/codemirror-graphql/utils/forEachState.js
// module id = ./node_modules/codemirror-graphql/utils/forEachState.js
// module chunks = 0